import i18next from 'i18next';

// ユーザー認証
export type AuthenticateType = {
  USER_ID: string;
  PASSWORD: string;
};

// ユーザー情報レスポンス
export type USER_INFO = {
  USER_ID: string;
  USER_NAME: string;
  DEF: boolean;
  SET_AUTH: boolean;
  SYSTEM_AUTH: boolean;
  REP_AUTH: boolean;
  IS_IOT: boolean;
  SystemSettingModel: SystemSettingModelType;
  ResponceData: ResponceDataType;
}

// ユーザー情報更新
export type USER_MNG = {
  ENT_NO: number;
  USER_ID: string;
  PASSWORD: string;
  USER_NAME: string;
  DEF: number;
  SET_AUTH: number;
  REP_AUTH: number;
  SYSTEM_AUTH: number;
  PASSWORD_EXPIRATION: string;
  USER_LOCK: number;
  PASSWORD_INPUTERROR_COUNT: number;
  MAIL_ADDRESS: string;
  TWO_PASSWORD_EXPIRATION: string;
  TWO_PASSWORD: string;
  isEdit: boolean;
  hasPassword: boolean;
};

// レスポンス情報
export type ResponceDataType = {
  ResponseCode: number;
  ErrorCode: number;
  ResponseMessage: string;
  ErrorMessage: string;
};

// パスワード更新情報
export type UpdatePasswordType = {
  USER_ID: string;
  PASSWORD: string;
  OLD_PASSWORD: string;
};

/**
 * システム設定情報
 */
export type SystemSettingModelType = {
  //3次元グラフボタン有効無効
  ThreeDButtonEnabled: number;
  //レポートボタン有効無効
  ReportButtonEnabled: number;
  //オフライン判定ボタン有効無効
  OffLineJudgeButtonEnabled: number;
  //コナンエアー画面有効無効
  ConanairEnabled: number;
  //Emcb画面有効無効
  EmcbEnabled: number;
  //部分放電画面有効無効
  PartialDischargeEnabled: number;
  //"ワンタイムパスワード処理有効無効
  OnetimePasswordEnable: number;
}

/**
 * 送信アクションレスポンス
 */
export type SendPasswordInfo = {
  USER_ID: string;
  ResponceData: ResponceDataType;
  OnetimePasswordValidityTime: number;
  AdminUserId: boolean;
}

export type EntryAdressModel = {
  USER_ID: string;
  MAIL_ADRESS: string;
};
/**
 * メールアドレス登録レスポンス
 */
export type EntryMailAdressInfo = {
  USER_ID: string;
  MAIL_ADRESS: string;
  ResponceData: ResponceDataType;
}


export const GetUserInfos = (): Promise<USER_MNG[]> => {
  //console.debug(["GetUserInfos()"]);
  return new Promise((resolve, reject) => {
    fetch("api/UserManage/Infos")
      .then((res) => res.json())
      .then((result: USER_MNG[]) => {
        if (GetUserInfosValidate(result)) resolve(result);

        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};
const GetUserInfosValidate = (data: USER_MNG[]): boolean => {
  if (data === undefined) {
    return false;
  }
  return true;
};

/**
 * ユーザー認証処理
 * @param user 
 * @param password 
 * @returns 
 */
export const AuthenticateUser = (user: string, password: string): Promise<USER_INFO> => {
  const param: AuthenticateType = { USER_ID: user, PASSWORD: password };

  return new Promise((resolve, reject) => {
    fetch("api/UserManage/Authenticate", {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(param),
    })
      .then((res) => res.json())
      .then((result: USER_INFO) => resolve(result))
      .catch(reason => reject(reason));
  });
}

export const UpdateUserInfos = (targetRows: USER_MNG[]): Promise<ResponceDataType> => {
  console.debug(["UpdateUserInfos-START", /* targetRows */]);
  return new Promise((resolve, reject) => {
    fetch("api/UserManage/UpdateRows", {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(targetRows),
    })
      .then((res) => res.json())
      .then((result: ResponceDataType) => resolve(result))
      .catch(reason => reject(reason));

  });
}

export const UpdatePassword = (user: string, password: string, oldPassword: string): Promise<ResponceDataType> => {
  const param: UpdatePasswordType = { USER_ID: user, PASSWORD: password, OLD_PASSWORD: oldPassword };


  return new Promise((resolve, reject) => {
    fetch("api/UserManage/UpdatePassword", {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(param),
    })
      .then((res) => res.json())
      .then((result: ResponceDataType) => resolve(result))
      .catch(reason => reject(reason));
  });
}


/**
 * パスワードが有効かを確認、英語、数字が少なくとも1個混在していること
 * @param password チェック対象のパスワード
 */
export const CheckPasswordFormat = (password: string, translation: any): string => {
  const regex = /^((?=.*[A-Z])|(?=.*[a-z]))(?=.*[0-9])/;

  if (password.length < 8) {
    return i18next.t('LoginUserSettingPage.パスワードは8文字以上入力してください', 'パスワードは8文字以上入力してください');
  }
  if (password.length > 40) {
    return i18next.t('LoginUserSettingPage.パスワードは12文字以内で入力してください', 'パスワードは40文字以内で入力してください');
  }
  if (!regex.test(password)) {
    return i18next.t('LoginUserSettingPage.パスワードには次の文字種を含めてください_英字_数字', 'パスワードには次の文字種を含めてください　英字　数字');
  }
  return "";
}

/**
 * 2段階認証処理が有効か確認する処理
 * @returns 
 */
export const GetLoginMode = (): Promise<boolean> => {
  console.debug(["GetLoginMode()"]);
  return new Promise((resolve, reject) => {
    fetch("api/UserManage/GetLoginMode")
      .then((res) => res.json())
      .then((result: boolean) => {
        resolve(result);

        reject('Invalidate response');
      },
        (error) => {
          console.log(["GetLoginMode", error]);
          reject(error);
        }
      );
  });
}

/**
 * ログアウト処理
 * @returns 
 */
export const GetLogoutMode = (): Promise<boolean> => {
  console.debug(["GetLogoutMode()"]);
  return new Promise((resolve, reject) => {
    fetch("api/UserManage/GetLogoutMode")
      .then((res) => res.json())
      .then((result: boolean) => {
        resolve(result);

        reject('Invalidate response');
      },
        (error) => {
          console.log(["GetLogoutMode", error]);
          reject(error);
        }
      );
  });
}

/**
 * 2段階認証パスワード送信処理
 * @param user 
 * @param password 
 * @returns 
 */
export const SendMailAction = (user: string, password: string): Promise<SendPasswordInfo> => {
  const param: AuthenticateType = { USER_ID: user, PASSWORD: password };

  return new Promise((resolve, reject) => {
    fetch("api/UserManage/SendPassword", {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(param),
    })
      .then((res) => res.json())
      .then((result: SendPasswordInfo) => resolve(result))
      .catch(reason => reject(reason));
  });

}

/**
 * 2段階認証 ログイン処理
 * @param user 
 * @param password 
 * @returns 
 */
export const OnetimeAuthenticate = (user: string, password: string): Promise<USER_INFO> => {
  const param: AuthenticateType = { USER_ID: user, PASSWORD: password };
  return new Promise((resolve, reject) => {
    fetch("api/UserManage/OnetimeAuthenticate", {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(param),
    })
      .then((res) => res.json())
      .then((result: USER_INFO) => resolve(result))
      .catch(reason => reject(reason));
  });

}

/**
 * メールアドレス登録処理
 * @param user 
 * @param adress 
 * @returns 
 */
export const EntryMailAction = (user: string, adress: string): Promise<EntryMailAdressInfo> => {
  const param: EntryAdressModel = { USER_ID: user, MAIL_ADRESS: adress };

  return new Promise((resolve, reject) => {
    fetch("api/UserManage/EntryMailAdress", {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(param),
    })
      .then((res) => res.json())
      .then((result: EntryMailAdressInfo) => resolve(result))
      .catch(reason => reject(reason));
  });
}